import { Directive, App, nextTick } from 'vue';

const autoFocusDirective: Directive = {
  mounted(el) {
    nextTick(() => {
      el.focus();
    });
  },
};

export function setupAutoFocusDirective(app: App) {
  app.directive('focus', autoFocusDirective);
}

export default autoFocusDirective;
